
<hr class="divider" :class="{ light: isLight, vertical: vertical }" />
